import { IProductsListPayload } from '../Services/api/products/products.interface';
import { TCategoryStore } from '../Services/api/categories/categories.interface';

export const PRODUCTS_LIST_PATH = '/products-list';

export function parseProductsListParams(searchParams: URLSearchParams): IProductsListPayload {
  const page = Math.max(1, Number.parseInt(searchParams.get('page') || '1', 10) || 1);
  const searchBy = searchParams.get('search') || undefined;
  const store = (searchParams.get('store') as TCategoryStore) || undefined;
  const brand = searchParams.get('brand') || undefined;
  const isActiveParam = searchParams.get('isActive');
  const isActive = isActiveParam !== null ? isActiveParam === 'true' : undefined;

  return { page, searchBy, store, brand, isActive };
}

export function buildProductsListSearchParams(filters: IProductsListPayload): URLSearchParams {
  const params = new URLSearchParams();

  if (filters.searchBy) {
    params.set('search', filters.searchBy);
  }
  if (filters.page > 1) {
    params.set('page', String(filters.page));
  }
  if (filters.store) {
    params.set('store', filters.store);
  }
  if (filters.brand) {
    params.set('brand', filters.brand);
  }
  if (filters.isActive !== undefined) {
    params.set('isActive', String(filters.isActive));
  }
  return params;
}

export function buildProductsListUrl(filters?: Partial<IProductsListPayload>): string {
  const params = buildProductsListSearchParams({
    page: filters?.page ?? 1,
    searchBy: filters?.searchBy,
    store: filters?.store,
    brand: filters?.brand,
    isActive: filters?.isActive ?? true,
  });
  const query = params.toString();
  return query ? `${PRODUCTS_LIST_PATH}?${query}` : PRODUCTS_LIST_PATH;
}

export function buildProductFormUrl(productId: string, returnTo?: string): string {
  const base = `/products-form/${productId}`;
  if (!returnTo) {
    return base;
  }
  return `${base}?return=${encodeURIComponent(returnTo)}`;
}

export function buildProductCreateUrl(returnTo?: string): string {
  if (!returnTo) {
    return '/products-form';
  }
  return `/products-form?return=${encodeURIComponent(returnTo)}`;
}
